var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinanace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 60C56.25 62.0711 57.9289 63.75 60 63.75C62.071 63.75 63.75 62.0711 63.75 60C63.75 57.9289 62.071 56.25 60 56.25C57.9289 56.25 56.25 57.9289 56.25 60Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2962 70.5431C47.9777 71.6667 50.3184 71.6667 55 71.6667H65C69.6815 71.6667 72.0223 71.6667 73.7038 70.5431C74.4317 70.0567 75.0567 69.4317 75.5431 68.7038C76.6666 67.0223 76.6666 64.6815 76.6666 60C76.6666 55.3185 76.6666 52.9777 75.5431 51.2962C75.0567 50.5683 74.4317 49.9433 73.7038 49.4569C72.0223 48.3333 69.6815 48.3333 65 48.3333H55C50.3184 48.3333 47.9777 48.3333 46.2962 49.4569C45.5682 49.9433 44.9432 50.5683 44.4568 51.2962C43.3333 52.9777 43.3333 55.3185 43.3333 60C43.3333 64.6815 43.3333 67.0223 44.4568 68.7038C44.9432 69.4317 45.5682 70.0567 46.2962 70.5431ZM60 66.25C56.5482 66.25 53.75 63.4518 53.75 60C53.75 56.5482 56.5482 53.75 60 53.75C63.4518 53.75 66.25 56.5482 66.25 60C66.25 63.4518 63.4518 66.25 60 66.25ZM49.1666 66.25C48.4763 66.25 47.9166 65.6904 47.9166 65L47.9166 55C47.9166 54.3096 48.4763 53.75 49.1666 53.75C49.857 53.75 50.4166 54.3096 50.4166 55L50.4166 65C50.4166 65.6904 49.857 66.25 49.1666 66.25ZM69.5833 65C69.5833 65.6904 70.143 66.25 70.8333 66.25C71.5237 66.25 72.0833 65.6904 72.0833 65V55C72.0833 54.3096 71.5237 53.75 70.8333 53.75C70.143 53.75 69.5833 54.3096 69.5833 55V65Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanace);
export default __webpack_public_path__ + "static/media/Finanace.e8450bc99389bd7a3f2e5209a9704aef.svg";
export { ForwardRef as ReactComponent };